export default __webpack_public_path__ + "static/media/tools-bg-circle.a4040134.svg";